const SkeletonLoaders = {
  configs: [],
  MARGIN_SIZES: {
    DEFAULT: "16px",
    SMALL: "8px",
    MEDIUM: "16px",
    LARGE: "64px"
  },
  WIDTHS: {
    DEFAULT: "100%",
    FORM_HEADING: "150px"
  },
  HEIGHTS: {
    DEFAULT: "48px",
    FORM_FIELD: "48px",
    FORM_HEADING: "24px",
    SHORT: "104px",
    MEDIUM: "136px",
    TALL: "240px",
    EXTRA_TALL: "560px"
  },

  // key: 1 key for 1 skeleton
  // groupId: 1 groupId for skeletons that appear at the same time
  // relatedSelector: ideally 1 element for 1 skeleton *
  //   *) multiple skeletons for 1 element can also work
  //      as long as they have the same groupId
  create(key, groupId, relatedSelector, { width, height, marginTop, marginBottom, marginLeft, marginRight, hide }) {
    if (hide) return null;
    const skeletonElement = document.createElement('div');
    skeletonElement.dataset.skeletonKey = key;
    skeletonElement.dataset.skeletonGroupId = groupId;
    skeletonElement.dataset.relatedSelector = relatedSelector;
    skeletonElement.classList.add("skeleton");
    skeletonElement.style.width = width || this.WIDTHS.DEFAULT;
    skeletonElement.style.height = height || this.HEIGHTS.DEFAULT;
    if (!!marginTop) {
      const marginSize = typeof marginTop === 'string' ? marginTop : this.MARGIN_SIZES.DEFAULT;
      skeletonElement.style.marginTop = marginSize;
    }
    if (!!marginBottom) {
      const marginSize = typeof marginBottom === 'string' ? marginBottom : this.MARGIN_SIZES.DEFAULT;
      skeletonElement.style.marginBottom = marginSize;
    }
    if (!!marginLeft) {
      const marginSize = typeof marginLeft === 'string' ? marginLeft : this.MARGIN_SIZES.DEFAULT;
      skeletonElement.style.marginLeft = marginSize;
    }
    if (!!marginRight) {
      const marginSize = typeof marginRight === 'string' ? marginRight : this.MARGIN_SIZES.DEFAULT;
      skeletonElement.style.marginRight = marginSize;
    }
    return skeletonElement;
  },

  createSkeletonConfigsOnCart() {
    const skeletonConfigs = [];
    const numberOfCartItems = document.querySelectorAll('.cart-items .cart-item').length;
    if (numberOfCartItems === 0) return [];
    for (let i = 1; i <= numberOfCartItems; i++) {
      skeletonConfigs.push({
        key: `cart-item-${i}`,
        groupId: "cart-items",
        relatedSelector: '.cart-items',
        options: {
          height: this.HEIGHTS.SHORT,
          marginBottom: this.MARGIN_SIZES.LARGE
        }
      });
    }
    skeletonConfigs.push({
      key: "cart-summary",
      groupId: "cart-summary",
      relatedSelector: '.cart__items-summary',
      options: {
        height: this.HEIGHTS.TALL,
        width: "calc(30% - 32px)",
        marginLeft: this.MARGIN_SIZES.MEDIUM,
        marginRight: this.MARGIN_SIZES.MEDIUM
      }
    })
    return skeletonConfigs;
  },

  createSkeletonConfigsOnCheckout() {
    const skeletonConfigs = [];
    switch (Shopify.Checkout.step) {
      case "contact_information":
        skeletonConfigs.push(
          {
            key: "shipping-method-heading",
            groupId: "shipping-method",
            relatedSelector: '#section-delivery-title',
            options: {
              width: this.WIDTHS.FORM_HEADING,
              height: this.HEIGHTS.FORM_HEADING,
              marginBottom: true
            }
          },
          {
            key: "shipping-method-content",
            groupId: "shipping-method",
            relatedSelector: 'div.section[data-shipping-address] > .section__content > .content-box',
            options: { height: this.HEIGHTS.SHORT }
          },
          {
            key: "shipping-address-heading",
            groupId: "shipping-address",
            relatedSelector: 'div.section[data-delivery-shipping-info] > .section__header',
            options: {
              width: this.WIDTHS.FORM_HEADING,
              height: this.HEIGHTS.FORM_HEADING,
              marginBottom: true
            }
          },
          {
            key: "shipping-address-country",
            groupId: "shipping-address",
            relatedSelector: 'div[data-delivery-shipping-info] .section__content',
            options: {
              height: this.HEIGHTS.FORM_FIELD,
              marginBottom: this.MARGIN_SIZES.SMALL
            }
          },
          {
            key: "shipping-address-name",
            groupId: "shipping-address",
            relatedSelector: 'div[data-delivery-shipping-info] .section__content',
            options: {
              height: this.HEIGHTS.FORM_FIELD,
              marginBottom: this.MARGIN_SIZES.SMALL
            }
          },
          {
            key: "shipping-address-address1",
            groupId: "shipping-address",
            relatedSelector: 'div[data-delivery-shipping-info] .section__content',
            options: {
              height: this.HEIGHTS.FORM_FIELD,
              marginBottom: this.MARGIN_SIZES.SMALL
            }
          },
          {
            key: "shipping-address-address2",
            groupId: "shipping-address",
            relatedSelector: 'div[data-delivery-shipping-info] .section__content',
            options: {
              height: this.HEIGHTS.FORM_FIELD,
              marginBottom: this.MARGIN_SIZES.SMALL
            }
          },
          {
            key: "shipping-address-city",
            groupId: "shipping-address",
            relatedSelector: 'div[data-delivery-shipping-info] .section__content',
            options: {
              height: this.HEIGHTS.FORM_FIELD,
              marginBottom: this.MARGIN_SIZES.SMALL
            }
          },
          {
            key: "shipping-address-province",
            groupId: "shipping-address",
            relatedSelector: 'div[data-delivery-shipping-info] .section__content',
            options: {
              height: this.HEIGHTS.FORM_FIELD,
              marginBottom: this.MARGIN_SIZES.SMALL
            }
          },
          {
            key: "shipping-address-zip",
            groupId: "shipping-address",
            relatedSelector: 'div[data-delivery-shipping-info] .section__content',
            options: {
              height: this.HEIGHTS.FORM_FIELD,
              marginBottom: this.MARGIN_SIZES.SMALL
            }
          },
          {
            key: "shipping-address-phone",
            groupId: "shipping-address",
            relatedSelector: 'div[data-delivery-shipping-info] .section__content',
            options: {
              height: this.HEIGHTS.FORM_FIELD,
              marginBottom: this.MARGIN_SIZES.SMALL
            }
          },
          {
            key: "pickup-location-heading",
            groupId: "pickup-location",
            relatedSelector: 'div.section[data-delivery-pickup-info] > .section__header',
            options: {
              width: this.WIDTHS.FORM_HEADING,
              height: this.HEIGHTS.FORM_HEADING,
              marginBottom: true
            }
          },
          {
            key: "pickup-location-options",
            groupId: "pickup-location",
            relatedSelector: 'div[data-pickup-tab-content]',
            options: { height: this.HEIGHTS.TALL }
          },
          {
            key: "submit-button",
            groupId: "footer",
            relatedSelector: '.step__footer',
            options: { hide: true }
          }
        );
        break;

      case "shipping_method":
        skeletonConfigs.push(
          {
            key: "shipping-method-heading",
            groupId: "shipping-method",
            relatedSelector: '.section.section--shipping-method > .section__header',
            options: {
              width: this.WIDTHS.FORM_HEADING,
              height: this.HEIGHTS.FORM_HEADING,
              marginBottom: true
            }
          },
          {
            key: "shipping-method-content",
            groupId: "shipping-method",
            relatedSelector: 'div.section.section--shipping-method > .section__content > .content-box',
            options: { height: this.HEIGHTS.MEDIUM }
          },
          {
            key: "submit-button",
            groupId: "footer",
            relatedSelector: '.step__footer',
            options: { hide: true }
          }
        );
        break;

      case "payment_method":
        const differentBillingAddressOption = document.querySelector('.radio-wrapper[data-different-billing-address] input.input-radio');
        skeletonConfigs.push(
          {
            key: "payment-summary-box",
            groupId: "summary",
            relatedSelector: '.step__sections > .section:first-child .content-box',
            options: {
              height: this.HEIGHTS.MEDIUM,
              marginBottom: this.MARGIN_SIZES.LARGE,
            }
          },
          {
            key: "payment-method-heading",
            groupId: "payment-method",
            relatedSelector: 'div.section[data-payment-method] > .section__header',
            options: {
              width: this.WIDTHS.FORM_HEADING,
              height: this.HEIGHTS.FORM_HEADING,
              marginBottom: true
            }
          },
          {
            key: "payment-method-content",
            groupId: "payment-method",
            relatedSelector: 'div.section[data-payment-method] > .section__content',
            options: { height: this.HEIGHTS.TALL }
          },
          {
            key: "billing-address-heading",
            groupId: "billing-address",
            relatedSelector: 'div.section[data-billing-address] > .section__header',
            options: {
              width: this.WIDTHS.FORM_HEADING,
              height: this.HEIGHTS.FORM_HEADING,
              marginBottom: true
            }
          },
          {
            key: "billing-address-content",
            groupId: "billing-address",
            relatedSelector: 'div.section[data-billing-address] > .section__content',
            options: {
              height: !differentBillingAddressOption || differentBillingAddressOption.checked
                ? this.HEIGHTS.EXTRA_TALL
                : this.HEIGHTS.MEDIUM
            }
          },
          {
            key: "submit-button",
            groupId: "footer",
            relatedSelector: '.step__footer',
            options: { hide: true }
          }
        );
        break;

      default:
        break;
    }
    return skeletonConfigs;
  },

  createSkeletonConfigsOnComingSoonPage() {
    const isSmallNumbers = document.body.clientWidth <= 384;
    const skeletonWidth = isSmallNumbers ? "200px" : "285px";
    const skeletonConfigs = [
      {
        key: "coming-soon-countdown",
        groupId: "coming-soon-countdown",
        relatedSelector: '.coming-soon__countdown',
        options: {
          height: "82px",
          width: skeletonWidth,
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: this.MARGIN_SIZES.MEDIUM,
          marginBottom: this.MARGIN_SIZES.MEDIUM
        }
      }
    ];
    return skeletonConfigs;
  },

  start(skeletonGroupId) {
    this.configs.forEach(config => {
      if (config.groupId === skeletonGroupId) {
        const relatedElement = document.querySelector(config.relatedSelector);
        relatedElement.style.display = "none";
        if (!config.options.hide) {
          const skeletonElement = document.querySelector(`[data-skeleton-key="${config.key}"]`);
          skeletonElement.style.display = "block";
        }
      }
    })
  },

  startAll() {
    this.configs.forEach(config => {
      const relatedElement = document.querySelector(config.relatedSelector);
      if (relatedElement) {
        relatedElement.style.display = "none";
      }
      if (!config.options.hide) {
        const skeletonElement = document.querySelector(`[data-skeleton-key="${config.key}"]`);
        skeletonElement.style.display = "block";
      }
    })
  },

  stop(skeletonGroupId) {
    this.configs.forEach(config => {
      if (config.groupId === skeletonGroupId) {
        const relatedElement = document.querySelector(config.relatedSelector);
        if (relatedElement) {
          relatedElement.style.display = "";
        }
        if (!config.options.hide) {
          const skeletonElement = document.querySelector(`[data-skeleton-key="${config.key}"]`);
          if (skeletonElement) {
            skeletonElement.style.display = "";
          }
        }
      }
    });
  },

  insertToDom(config) {
    const relatedElement = document.querySelector(config.relatedSelector);
    if (!config.options.hide) {
      const newSkeletonElement = this.create(config.key, config.groupId, config.relatedSelector, config.options);
      // insert newSkeletonElement after relatedElement
      relatedElement.parentNode.insertBefore(newSkeletonElement, relatedElement.nextSibling);
    }
  },

  insertAllOnPage(pageTemplate) {
    switch(pageTemplate) {
      case "checkout":
        this.configs = this.createSkeletonConfigsOnCheckout();
        break;
      case "cart":
        this.configs = this.createSkeletonConfigsOnCart();
        break;
      case "page.coming-soon":
        this.configs = this.createSkeletonConfigsOnComingSoonPage();
        break;
      default:
        break;
    }
    this.configs.forEach(config => {
      this.insertToDom(config);
    });
  }
}

SkeletonLoaders.insertAllOnPage(currentPageTemplate);
SkeletonLoaders.startAll();

